import React, { Component } from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './containers/App';
import DashboardPage from './containers/DashboardPage';
import LoginPage from './containers/LoginPage';
import ProductsPage from './containers/ProductsPage';
import ProductEditPage from './containers/ProductEditPage';
import ProductNewPage from './containers/ProductNewPage';
import ProductViewPage from './containers/ProductViewPage';
import CatalogsPage from './containers/CatalogsPage';
import CatalogEditPage from './containers/CatalogEditPage';
import CatalogNewPage from './containers/CatalogNewPage';
import CatalogViewPage from './containers/CatalogViewPage';
import CatalogSortPage from './containers/CatalogSortPage';
import ItemsPage from './containers/ItemsPage';
import ItemEditPage from './containers/ItemEditPage';
import ItemNewPage from './containers/ItemNewPage';
import OptionsPage from './containers/OptionsPage';
import OptionEditPage from './containers/OptionEditPage';
import OptionNewPage from './containers/OptionNewPage';
import OptionViewPage from './containers/OptionViewPage';
import OptionGroupsPage from './containers/OptionGroupsPage';
import OptionGroupEditPage from './containers/OptionGroupEditPage';
import OptionGroupNewPage from './containers/OptionGroupNewPage';
import OptionGroupViewPage from './containers/OptionGroupViewPage';
import TaxratePage from './containers/TaxratePage';
import TaxrateEditPage from './containers/TaxrateEditPage';
import TaxrateNewPage from './containers/TaxrateNewPage';
import TaxrateViewPage from './containers/TaxrateViewPage';
import CategoriesPage from './containers/CategoriesPage';
import CategoryEditPage from './containers/CategoryEditPage';
import CategoryNewPage from './containers/CategoryNewPage';
import CategoryViewPage from './containers/CategoryViewPage';
import SettingsPage from './containers/SettingsPage';
import AdminsPage from './containers/AdminsPage';
import AdminEditPage from './containers/AdminEditPage';
import AdminNewPage from './containers/AdminNewPage';
import AdminViewPage from './containers/AdminViewPage';
import CampaignLogViewPage from './containers/logging/campaigns/CampaignViewPage';
import CampaignsLogPage from './containers/logging/campaigns/CampaignsPage';
import NoPermissionPage from './containers/NoPermissionPage';
import SalesChannelsPage from './containers/SalesChannelsPage';
import SalesChannelEditPage from './containers/SalesChannelEditPage';
import SalesChannelNewPage from './containers/SalesChannelNewPage';
import SalesChannelViewPage from './containers/SalesChannelViewPage';
import CampaignsPage from './containers/CampaignsPage';
import CampaignEditPage from './containers/CampaignEditPage';
import CampaignNewPage from './containers/CampaignNewPage';
import CampaignViewPage from './containers/CampaignViewPage';
import OrdersPage from './containers/OrdersPage';
import OrderEditPage from './containers/OrderEditPage';
import EventsPage from './containers/EventsPage';
import EventViewPage from './containers/EventViewPage';
import DiscountsPage from './containers/DiscountsPage';
import DiscountEditPage from './containers/DiscountEditPage';
import DiscountNewPage from './containers/DiscountNewPage';
import PromotionsPage from './containers/PromotionsPage';
import PromotionEditPage from './containers/PromotionEditPage';
import PromotionNewPage from './containers/PromotionNewPage';
import PromotionViewPage from './containers/PromotionViewPage';
import GiftCardsPage from './containers/GiftCardsPage';
import GiftCardNewPage from './containers/GiftCardNewPage';
import GiftCardViewPage from './containers/GiftCardViewPage';
import GiftCardEditPage from './containers/GiftCardEditPage';
import ReportingPage from './containers/ReportingPage';
import ArticlesPage from './containers/ArticlesPage';
import ArticlesNewPage from './containers/ArticlesNewPage';
import ArticlesEditPage from './containers/ArticlesEditPage';
import BoxesPage from './containers/BoxesPage'
import BoxesNewPage from './containers/BoxesNewPage'
import BoxesEditPage from './containers/BoxesEditPage'
import OverlaysPage from './containers/OverlaysPage'
import OverlaysNewPage from './containers/OverlaysNewPage'
import OverlaysEditPage from './containers/OverlaysEditPage'

const Authorization = (allowedRoles) => (WrappedComponent) => { // eslint-disable-line arrow-body-style
  return class WithAuthorization extends Component {
    constructor(props) {
      super(props);
      this.state = {
        alertOpen: true,
        alertMessage: 'You do not have the correct permissions',
        role: localStorage.getItem('scope'),
      };
    }
    render() {
      const role = parseInt(this.state.role, 10);
      if (allowedRoles.includes(role)) {
        return <WrappedComponent {...this.props} />;
      }
      return (<NoPermissionPage {...this.props} />);
    }
  };
};

const superAdmin = 0; // eslint-disable-line new-cap
const admin = 1; // eslint-disable-line new-cap
const operator = 2; // eslint-disable-line new-cap
const fulfillment = 3;
const readOnly = 4;

export default (
  <Route path="/" component={App}>
    <IndexRoute component={LoginPage} />
    <Route path="/dashboard" component={Authorization([superAdmin, admin, operator, fulfillment, readOnly])(DashboardPage)} />
    <Route path="/logging/campaigns" component={Authorization([superAdmin, admin, readOnly])(CampaignsLogPage)} />
    <Route path="/logging/campaigns/:id" component={Authorization([superAdmin, admin, readOnly])(CampaignLogViewPage)} />
    <Route path="/products" component={Authorization([superAdmin, admin, operator, readOnly])(ProductsPage)} />
    <Route path="/products/new" component={Authorization([superAdmin, admin])(ProductNewPage)} />
    <Route path="/products/view/:id" component={Authorization([superAdmin, admin, operator, readOnly])(ProductViewPage)} />
    <Route path="/products/:id" component={Authorization([superAdmin, admin])(ProductEditPage)} />
    <Route path="/catalogs" component={Authorization([superAdmin, admin, readOnly])(CatalogsPage)} />
    <Route path="/catalogs/new" component={Authorization([superAdmin, admin])(CatalogNewPage)} />
    <Route path="/catalogs/view/:id" component={Authorization([superAdmin, admin, readOnly])(CatalogViewPage)} />
    <Route path="/catalogs/sort/:id" component={Authorization([superAdmin, admin, readOnly])(CatalogSortPage)} />
    <Route path="/catalogs/:id" component={Authorization([superAdmin, admin])(CatalogEditPage)} />
    <Route path="/items" component={Authorization([superAdmin, admin, operator, readOnly])(ItemsPage)} />
    <Route path="/items/new" component={Authorization([superAdmin, admin])(ItemNewPage)} />
    <Route path="/items/:id" component={Authorization([superAdmin, admin])(ItemEditPage)} />
    <Route path="/taxrate" component={Authorization([superAdmin, admin, operator, readOnly])(TaxratePage)} />
    <Route path="/taxrate/new" component={Authorization([superAdmin, admin])(TaxrateNewPage)} />
    <Route path="/taxrate/view/:zipcode" component={Authorization([superAdmin, admin, operator, readOnly])(TaxrateViewPage)} />
    <Route path="/taxrate/:zipcode" component={Authorization([superAdmin, admin])(TaxrateEditPage)} />
    <Route path="/options" component={Authorization([superAdmin, admin, readOnly])(OptionsPage)} />
    <Route path="/options/new" component={Authorization([superAdmin, admin])(OptionNewPage)} />
    <Route path="/options/view/:id" component={Authorization([superAdmin, admin, readOnly])(OptionViewPage)} />
    <Route path="/options/:id" component={Authorization([superAdmin, admin])(OptionEditPage)} />
    <Route path="/optiongroups" component={Authorization([superAdmin, admin, readOnly])(OptionGroupsPage)} />
    <Route path="/optiongroups/new" component={Authorization([superAdmin, admin])(OptionGroupNewPage)} />
    <Route path="/optiongroups/view/:id" component={Authorization([superAdmin, admin, readOnly])(OptionGroupViewPage)} />
    <Route path="/optiongroups/:id" component={Authorization([superAdmin, admin])(OptionGroupEditPage)} />
    <Route path="/categories" component={Authorization([superAdmin, admin, readOnly])(CategoriesPage)} />
    <Route path="/categories/new" component={Authorization([superAdmin, admin])(CategoryNewPage)} />
    <Route path="/categories/view/:id" component={Authorization([superAdmin, admin, readOnly])(CategoryViewPage)} />
    <Route path="/categories/:id" component={Authorization([superAdmin, admin])(CategoryEditPage)} />
    <Route path="/admins" component={Authorization([superAdmin])(AdminsPage)} />
    <Route path="/admins/new" component={Authorization([superAdmin])(AdminNewPage)} />
    <Route path="/admins/view/:id" component={Authorization([superAdmin])(AdminViewPage)} />
    <Route path="/admins/:id" component={Authorization([superAdmin])(AdminEditPage)} />
    <Route path="/settings" component={Authorization([superAdmin, admin, readOnly])(SettingsPage)} />
    <Route path="/saleschannels" component={Authorization([superAdmin, admin, readOnly])(SalesChannelsPage)} />
    <Route path="/saleschannels/new" component={Authorization([superAdmin, admin])(SalesChannelNewPage)} />
    <Route path="/saleschannels/view/:id" component={Authorization([superAdmin, admin, readOnly])(SalesChannelViewPage)} />
    <Route path="/saleschannels/:id" component={Authorization([superAdmin, admin])(SalesChannelEditPage)} />
    <Route path="/campaigns" component={Authorization([superAdmin, admin, readOnly])(CampaignsPage)} />
    <Route path="/campaigns/new" component={Authorization([superAdmin, admin])(CampaignNewPage)} />
    <Route path="/campaigns/view/:id" component={Authorization([superAdmin, admin, readOnly])(CampaignViewPage)} />
    <Route path="/campaigns/:id" component={Authorization([superAdmin, admin])(CampaignEditPage)} />
    <Route path="/orders" component={Authorization([superAdmin, admin, operator, fulfillment, readOnly])(OrdersPage)} />
    <Route path="/orders/:id" component={Authorization([superAdmin, admin, operator, fulfillment, readOnly])(OrderEditPage)} />
    <Route path="/events" component={Authorization([superAdmin, admin, operator, readOnly])(EventsPage)} />
    <Route path="/events/view/:id" component={Authorization([superAdmin, admin, operator, readOnly])(EventViewPage)} />
    <Route path="/discounts" component={Authorization([superAdmin, admin, operator, readOnly])(DiscountsPage)} />
    <Route path="/discounts/new" component={Authorization([superAdmin, admin])(DiscountNewPage)} />
    <Route path="/discounts/:id" component={Authorization([superAdmin, admin])(DiscountEditPage)} />
    <Route path="/promotions" component={Authorization([superAdmin, admin, operator, readOnly])(PromotionsPage)} />
    <Route path="/promotions/new" component={Authorization([superAdmin, admin])(PromotionNewPage)} />
    <Route path="/promotions/view/:id" component={Authorization([superAdmin, admin, operator, readOnly])(PromotionViewPage)} />
    <Route path="/promotions/:id" component={Authorization([superAdmin, admin])(PromotionEditPage)} />
    <Route path="/giftcards/view/:id" component={Authorization([superAdmin, admin, operator])(GiftCardViewPage)} />
    <Route path="/giftcards/edit/:id" component={Authorization([superAdmin, admin])(GiftCardEditPage)} />
    <Route path="/giftcards" component={Authorization([superAdmin, admin, operator])(GiftCardsPage)} />
    <Route path="/giftcards/new" component={Authorization([superAdmin, admin])(GiftCardNewPage)} />
    <Route path="/reporting" component={Authorization([superAdmin, admin, readOnly])(ReportingPage)} />
    <Route path="/articles" component={Authorization([superAdmin, admin])(ArticlesPage)} />
    <Route path="/articles/new" component={Authorization([superAdmin, admin])(ArticlesNewPage)} />
    <Route path="/articles/:id" component={Authorization([superAdmin, admin])(ArticlesEditPage)} />
    <Route path="/boxes" component={Authorization([superAdmin, admin])(BoxesPage)} />
    <Route path="/boxes/new" component={Authorization([superAdmin, admin])(BoxesNewPage)} />
    <Route path="/boxes/edit/:id" component={Authorization([superAdmin, admin])(BoxesEditPage)} />
    <Route path="/overlays" component={Authorization([superAdmin, admin])(OverlaysPage)} />
    <Route path="/overlays/new" component={Authorization([superAdmin, admin])(OverlaysNewPage)} />
    <Route path="/overlays/edit/:id" component={Authorization([superAdmin, admin])(OverlaysEditPage)} />
    <Route path="*" component={App} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js